import { render, staticRenderFns } from "./ComplementaryContent.vue?vue&type=template&id=c27014d4&scoped=true&"
import script from "./ComplementaryContent.vue?vue&type=script&lang=js&"
export * from "./ComplementaryContent.vue?vue&type=script&lang=js&"
import style0 from "./ComplementaryContent.vue?vue&type=style&index=0&id=c27014d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27014d4",
  null
  
)

component.options.__file = "ComplementaryContent.vue"
export default component.exports